<template>
    <div class="redemptionplan">
      <b-progress :max="max" height="2rem" variant="success" class="bg-secondary" v-if="max">
        <b-progress-bar :value="value">
          План погашения: <strong>{{ value | formatNumber }} / {{ max | formatNumber }}</strong>
        </b-progress-bar>
      </b-progress>
    </div>
</template>

<script>
export default {
  data() {
    return {
      max: 0,
      value: 0,
    };
  },
  created() {
    this.getRedemptionplan();
  },
  methods: {
    getRedemptionplan() {
      window.axios.get('/users/progress/redemptionplan')
        .then((res) => {
          if (res.data.payment_amount) {
            this.value = res.data.payment_amount;
          }
          if (res.data.redemption_amount) {
            this.max = res.data.redemption_amount;
          }
        });
    },
  },
};
</script>
